export default __webpack_public_path__ + "static/media/CostomiseLength1.84de830b.PNG";